import { Injectable } from '@angular/core';
import { SongFormConfig } from '../config/song-form-config';
import { Storage, ref, uploadBytes, getDownloadURL } from '@angular/fire/storage';
import { AlertController, getPlatforms, isPlatform, NavController } from '@ionic/angular';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root',
})
export class AdminService {
  keyboardOpened = false;
  keyboardHeight = 0;

  constructor(private storage: Storage,
        private navCtrl: NavController,
        private alertCtrl: AlertController,
  ) {}

  async loadLocaleConfig(lang: string): Promise<SongFormConfig> {
    const r = await fetch(`/assets/formConfig/songCreationForm-${lang}.json`);
    return await r.json();
  }

  async uploadUserImage(userId: string, file: File): Promise<string> {
    const path = `users/${userId}/${file.name}`;
    const storageRef = ref(this.storage, path);
    await uploadBytes(storageRef, file);
    return getDownloadURL(storageRef);
  }

  /**
   * Basis-URL fuer geteilte Links (Share- und Geschenkseiten).
   *
   * Im Browser das echte origin: dann erzeugt ein lokaler Test lokale Links und
   * dev.melowish.com dev-Links. In der native App gibt es kein brauchbares
   * origin (capacitor://localhost), dort kommt der Wert aus der Environment.
   *
   * Vorher stand diese Entscheidung dreimal dupliziert in song-detail und
   * present, jeweils mit hartcodierter Prod-Domain.
   */
  getAppBaseUrl(): string {
    if (this.isNativeMobile()) {
      return environment.appBaseUrl;
    }
    return window.location.origin;
  }

  isNativeMobile(): boolean {
    // Robust genug als Heuristik: Wenn du Capacitor nutzt, ersetze es durch Capacitor.isNativePlatform()
    console.log("platform:",getPlatforms())
    // return isPlatform('mobileweb') || isPlatform('android') || isPlatform('ios');
    return !isPlatform('mobileweb') && (isPlatform('android') || isPlatform('ios'));
  }
  isMobile(): boolean {
    // Robust genug als Heuristik: Wenn du Capacitor nutzt, ersetze es durch Capacitor.isNativePlatform()
    // console.log("platform:",getPlatforms())
    // return isPlatform('mobileweb') || isPlatform('android') || isPlatform('ios');
    return isPlatform('mobileweb') || isPlatform('android') || isPlatform('ios');
  }
  isDesktop(): boolean {
    return !isPlatform('android') && !isPlatform('ios');
  }

    async commingSoon() {
    let errHeader = "Comming Soon";
    let errMsg = "Leider ist eine Registrierung noch nicht möglich. Wir sind in Kürze für Euch da!";
    let errButtons: any = [{ text: "Ok", role: "cancel" }];
    const alert = await this.alertCtrl.create({
        header: errHeader,
        message: errMsg,
        buttons: errButtons,
    });
    await alert.present();
  }

}
